import styled, { css } from 'styled-components'
import { Button, Tooltip } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import theme from 'src/styles/theme'
import { Red } from '../../assets/colors'

export const Table = styled.table<{ border?: string }>`
  width: 100%;
  display: inline-block;
  ${({ border = '1px solid #c7c9c7' }) => css`
      border: ${border};
    `}
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.12);
`

export const THead = styled.thead<{ borderBottom?: string, borderTop?: string, borderRadius?: number }>`
  width: 100%;
  flex: 1;
  display: flex;
  ${({ borderBottom = '1px solid #c7c9c7' }) => css`
      border-bottom: ${borderBottom};
    `}
  ${({ borderTop = 'none' }) => css`
      border-top: ${borderTop};
    `}
  flex-direction: column;
  border-radius: ${({ borderRadius }) => (borderRadius != null ? `${borderRadius}!important` : undefined)} ;
`

export const TBody = styled.tbody`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const THeadTR = styled.tr`
  display: flex;
  flex: 1;
`

export const TBodyTR = styled.tr<{
  backgroundColor?: string,
  isHover?: boolean,
  cursor?: string,
  clicked?: boolean
}>`

  color: #666666;
  ${({ backgroundColor }) => (backgroundColor
    ? css`
          background-color: ${backgroundColor};
        `
    : css`
          &:nth-child(odd) {
            background-color: #f0f0f0;
          }

          &:nth-child(even) {
            background-color: #ffffff;
          }
        `)}

  ${({ isHover = true }) => isHover
    && css`
      &:hover {
        background-color: #d4e7fc;
        color: #000;
        font-weight: bold;
      }
    `}

  ${({ cursor }) => cursor
    && css`
      cursor: ${cursor};
    `}

  display: flex;
  flex: 1;
  align-items: center;
`

export const TH = styled.th<{ flex?: number, textAling?: string, boxShadow?: string, padding?: string, isAction?: boolean }>`
  display: flex;
  align-items: ${(props) => (props.isAction ? 'center' : 'start')};
  justify-content: center;
  background-color: inherit;
  color: inherit;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  flex-direction: column;
  position: relative;
  ${({ flex = 1 }) => css`
      flex: ${flex};
    `}
  ${({ textAling = 'left' }) => css`
      text-align: ${textAling} !important;
    `}
  ${({ boxShadow = 'unset' }) => css`
      box-shadow: -${boxShadow}, ${boxShadow} !important;
    `}
  ${({ padding = '8px 22px' }) => css`
      padding: ${padding} !important;
    `}
`

export const TD = styled.td<{ flex?: number, textAlign?: string, isAction?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.isAction ? 'center' : 'start')};
  padding: 8px 22px;
  background-color: inherit;
  color: inherit;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  ${({ textAlign = 'right' }) => css`
      text-align: ${textAlign};
    `};
  ${({ flex = 1 }) => css`
      flex: ${flex};
    `}
  overflow: auto;
`
export const ColumnNameWithTooltip = styled.div<{alert?: boolean}>`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  gap: 5px;
  color: ${({ alert }) => alert && theme.colors.red};
`

export const CellTolltip = styled(Tooltip)`
  cursor: pointer;
`
export const InfoIcon = styled(InfoOutlinedIcon)`
  font-size: 16px !important;
  color: ${theme.colors.darkGray} !important;

`

export const ButtonDate = styled(Button)`
  padding: 0 !important;
`
export const Text = styled.div<{isDamage?: boolean}>`
  display: flex;
  color: ${(props) => (props.isDamage ? Red : '')};
  align-items: center;
  justify-content: center;
`
